const recaptchaVerify = async () => {
    await window.grecaptcha.reset(); // For chained requests
    return await window.grecaptcha.execute();
};

export default recaptchaVerify;
